// extracted by mini-css-extract-plugin
module.exports = {"similarProducts":"SimilarProducts_similarProducts__KURfZ","moreButton":"SimilarProducts_moreButton__1bzOh","similarProductsHeading":"SimilarProducts_similarProductsHeading__ARcfy"};